import React from 'react';
import { motion } from 'framer-motion';
import { LuPhone } from 'react-icons/lu';
import { FaWhatsapp } from 'react-icons/fa';


const styles = {
  maintenanceContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #334155 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
    fontFamily: "'Montserrat', sans-serif",
    color: '#e2e8f0',
    textAlign: 'center',
  },
  maintenanceCard: {
    background: 'rgba(255,255,255, 0.95)',
    backdropFilter: 'blur(10px)',
    borderRadius: '24px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
    padding: '48px 40px',
    width: '100%',
    maxWidth: '600px',
    display: 'flex', // Adicionado para organizar logo e conteúdo
    flexDirection: 'column', // Adicionado para organizar logo e conteúdo
    alignItems: 'center', // Centraliza itens no card
  },
  logo: {
    maxWidth: '150px', // Tamanho ajustável para a logo
    marginBottom: '2rem',
  },
  iconWrapper: {
    fontSize: '4rem',
    color: '#3b82f6',
    marginBottom: '2rem',
  },
  title: {
    fontSize: '2.5rem',
    fontWeight: 700,
    color: '#272727ff',
    marginBottom: '1rem',
  },
  message: {
    fontSize: '1.125rem',
    color: '#3a3a3aff',
    whiteSpace: 'pre-wrap',
    marginBottom: '2rem',
  },
  contactInfoContainer: { // Novo estilo para agrupar os links de contato
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    marginBottom: '2rem',
    width: '100%', // Para ocupar a largura total do card
    alignItems: 'center', // Centraliza os botões
  },
  contactButton: {
    backgroundColor: '#3b82f6',
    color: '#333333ff',
    border: 'none',
    borderRadius: '14px',
    padding: '15px 25px',
    fontSize: '1.1rem',
    fontWeight: 600,
    textDecoration: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    maxWidth: '300px', // Limita a largura dos botões
    width: '100%',
  },
  contactButtonHover: {
    backgroundColor: '#1e3a8a',
  },
  closingMessage: {
    whiteSpace: 'pre-wrap',
    fontSize: '1rem',
    color: '#333333ff',
  },
};

const MaintenancePage = ({ config }) => {
  const { title, message, contactInfo, closingMessage } = config;

  // Garante que contactInfo é um objeto, caso contrário, usa um fallback
  const finalContactInfo = typeof contactInfo === 'object' && contactInfo !== null
    ? contactInfo
    : { phoneNumber: '08000213460', displayPhoneNumber: '0800-021-3460', whatsappNumber: '', whatsappMessage: '' };


  const whatsappLink = `https://wa.me/${finalContactInfo.whatsappNumber}?text=${encodeURIComponent(finalContactInfo.whatsappMessage)}`;

  return (
    <div style={styles.maintenanceContainer}>
      <motion.div 
        style={styles.maintenanceCard}
        initial={{ opacity: 0, scale: 0.95, y: -20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* Logo da empresa */}
        <img src="/logo2.png" alt="Logo da Empresa" style={styles.logo} />

        <h1 style={styles.title}>{title}</h1>
        <p style={styles.message}>{message}</p>
        
        <div style={styles.contactInfoContainer}>
            {/* Link para ligar */}
            {finalContactInfo.displayPhoneNumber && (
                <a 
                    href={`tel:${finalContactInfo.phoneNumber}`} 
                    style={styles.contactButton}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = styles.contactButtonHover.backgroundColor}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = styles.contactButton.backgroundColor}
                >
                    <LuPhone />
                    Ligar: {finalContactInfo.displayPhoneNumber}
                </a>
            )}

            {/* Link para WhatsApp */}
            {finalContactInfo.whatsappNumber && (
                <a 
                    href={whatsappLink} 
                    target="_blank" 
                    rel="noopener noreferrer" 
                    style={{...styles.contactButton, backgroundColor: '#25D366'}} // Cor do WhatsApp
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#1DA851'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#25D366'}
                >
                    <FaWhatsapp />
                    Falar pelo WhatsApp
                </a>
            )}
        </div>

        <p style={styles.closingMessage}>{closingMessage}</p>
      </motion.div>
    </div>
  );
};

export default MaintenancePage;

